module.exports = __webpack_public_path__ + "static/media/sort.4e77edce.svg";